<ng-template #copyLinkTemplate let-valueinput="value">
  <a href="{{valueinput}}" target="_blank" alt="download">{{valueinput}}</a>
  <a class="ms-2" [routerLink]="[]" (click)="copyLink(valueinput)" title="Copy link"><i class="far fa-sm fa-copy"></i></a>
</ng-template>

<ng-template #globalAppclientTemplate let-valueinput="value">
    {{valueinput === null ? 'Global' : getAppClientLabel(valueinput)}}
</ng-template>

<app-crud-list [observabledata]="observabledata"
               [displayedColumns]="displayedcolumns"
               [postTreatmentCallback]="getPostTreatmentCallback()"
               [idColumnName]="'id'"
               [entityroot]="entityroot"
               [deleteEntityHandler]="deleteEntityHandler()"
               [removePostTreatmentHandler]="deletePostTreatmentHandler()"
               [listEditPathCallback]="getListEditPathCallback()"
               [editable]="false"
               [readable]="false"
               [createButtonLabel]="createButtonLabel"
               [specificColumnsTemplates]="[
                  {key: 'uri', template: copyLinkTemplate},
                  {key: 'appclientid', template: globalAppclientTemplate}
               ]">
</app-crud-list>
